import { render } from "./PageNotFound.vue?vue&type=template&id=556b8e85&scoped=true&ts=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"

import "./PageNotFound.vue?vue&type=style&index=0&id=556b8e85&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556b8e85"]])

export default __exports__